Wee.fn.make('detailSlides', {
	init: function() {
		var priv = this.$private,
			$slideLinks = $('ref:detailSlideLinks'),
			$slideFilter = $('ref:slideFilter'),
			$anchor = $('ref:detailSlidesAnchor'),
			hash = $.routes.uri().hash,
			offset = $anchor.offset().top;

		priv.createTarget();

		$slideLinks.data('index', function(i) {
			return i;
		}).on('click.detailSlides', function(e, el) {
			var $el = $(el),
				data = $el.data();

			priv.loadTarget(data.index, data.id);
		});


		if ($slideFilter.length) {
			$slideFilter.on('change.detailSlides', function(e, el) {
				var val = $(el).val(),
					path = '/our-people',
					params = {
						path: path
					},
					query;

				if (val) {
					query = $.serialize({
						brand: val
					});

					path += '?' + query
				}

				if (query.length) {
					params = {
						path: path,
						scrollTop: offset
					}
				}
				$.history.go(params);
			});
		}

		// If window hash, load with detail view open
		if (hash) {
			var $slide = $('[data-hash="' + hash + '"]'),
				data = $slide.data();

			if ($slide.length) {
				priv.loadTarget(data.index, data.id);
			}
		}

		// Reposition detail and nav elements on screen resize
		Wee.screen.map([
			{
				min: 1,
				max: 6,
				each: true,
				callback: function() {
					priv.positionTarget();
				}
			}
		]);

		if (Object.keys($.routes.uri().query).length) {

			if (Wee.header.isStuck()) {
				offset -= 91;
			}

			Wee.header.hideHeader();
 			Wee.header.pauseHeader();
			$.animate.tween($._body, {
				scrollTop: offset
			}, {
				complete: function() {
					Wee.header.resumeHeader();
				}
			});
		}
	},

	/**
	 * Unbind all detail slide events
	 */
	unload: function() {
		$.events.off(false, '.detailSlides');

		// Here destory the detail app view instances
		if (Wee.app.detailSlide) {
			Wee.app.detailSlide.$destroy();
		}
	}
}, {
	/**
	 * Load detail data from hidden element or elementApi using entry ID
	 *
	 * @param {int} index
	 * @param {int} [entryId]
	 */
	loadTarget: function(index, entryId) {
		var scope = this,
			$slide = $('ref:detailSlideLinks').eq(index),
			slug = $slide.data('hash'),
			pageData = $.get('pageData'),
			entryData,
			entryDataIndex;
		scope.index = index;

		if (! entryId) {
			entryId = $slide.data('id');
		}

		entryDataIndex = pageData.map(function(o) {
			return o.id;
		}).indexOf(entryId.toString());

		entryData = pageData[entryDataIndex];

		scope.$details.addClass('-is-loading');

		if (entryData) {
			$._win.location.hash = slug;
			scope.renderTarget(pageData[entryDataIndex]);
		} else {
			console.error('Data not found for this selection: ', entryId);
		}
	},

	/**
	 * Render the member data into the application
	 *
	 * @param {object} data
	 */
	renderTarget: function(data) {
		this.savedPosition = $.scrollTop();
		this.positionTarget();

		Wee.app.detailSlide.$set(data);

		this.$openSlide.show();

		Wee.header.hideHeader();
		$.set('pauseHeader', true);

		$.animate.tween($._body, {
			scrollTop: this.$details.parent('.js-detail-slide').offset().top
		}, {
			complete: function() {
				$.set('pauseHeader', false);
			}
		});
	},

	/**
	 * Generate the slide detail wrapper structure on initial event
	 */
	createTarget: function() {
		var scope = this,
			$prev = $('<div class="detail-slide__nav -prev" />'),
			$next = $('<div class="detail-slide__nav -next" />'),
			$close = $('<div class="detail-slide__nav -close" />');
		scope.$openSlide = $('<li class="detail-slide js-detail-slide js-hide" />');
		scope.$details = $('<div class="detail-slide__inner" />');

		$prev.on('click.detailSlides', function() {
			scope.navigate();
		});

		$next.on('click.detailSlides', function() {
			scope.navigate(true);
		});

		$close.on('click.detailSlides', function() {
			scope.close();
		});

		$($._body).on('keydown.detailSlides', function(e) {
			if (e.keyCode == 37) {
				scope.navigate();
			} else if (e.keyCode == 39) {
				scope.navigate(true);
			} else if (e.keyCode == 27) {
				scope.close();
			}
		});

		scope.$openSlide
			.append($prev)
			.append($next)
			.append($close)
			.append(scope.$details)
			.appendTo('ref:detailSlides');

		$.app.make('detailSlide', {
			view: 'detailSlide',
			target: scope.$details
		});
	},

	/**
	 * Calculate and insert the bio before or after the current row
	 */
	positionTarget: function() {
		var $slides = $('ref:detailSlideLinks'),
			size = $.screen.size(),
			columns = 1,
			pos;

		if ($slides.length < 4 && size >= 4) {
			columns = $slides.length;
		} else if (size >= 4) {
			columns = 4;
		} else if (size > 2) {
			columns = 2;
		}

		pos = (Math.ceil((this.index + 1) / columns) * columns) - 1;

		if (pos === $slides.length) {
			pos = pos - columns;
		}

		if (pos >= 0) {
			this.$openSlide.insertAfter(
				$.parent($slides.eq(pos))
			);
		}
	},

	/**
	 * Move forward or backwards through the members
	 *
	 * @param (next=false)
	 */
	navigate: function(next) {
		var $slides = $('ref:detailSlideLinks'),
			total = $slides.length,
			index = 0;

		if (next) {
			index = this.index + 1 < total ? this.index + 1 : 0;
		} else {
			index = ! this.index ? total - 1 : this.index - 1;
		}

		this.loadTarget(index);
	},

	/**
	 * Close the currently open member detail
	 */
	close: function() {
		this.$openSlide.hide();
		Wee.common.removeHash();

		// Scroll to previous position
		$.animate.tween($._body, {
			scrollTop: this.savedPosition
		});
	}
});